// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface PartialBook
 */
export interface PartialBook {
    /**
     * 
     * @type {string}
     * @memberof PartialBook
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBook
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBook
     */
    type: PartialBookTypeEnum;
}

export function PartialBookFromJSON(json: any): PartialBook {
    return {
        'id': json['id'],
        'title': json['title'],
        'type': json['type'],
    };
}

export function PartialBookToJSON(value?: PartialBook): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'title': value.title,
        'type': value.type,
    };
}

/**
* @export
* @enum {string}
*/
export enum PartialBookTypeEnum {
    Book = 'book'
}


